import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BookOpen, Heart, AlertCircle, Scale, Quote } from 'lucide-react';
import { realDecisions } from '../../data/toolsData';

const iconMap = {
  Heart: Heart,
  AlertCircle: AlertCircle,
  Scale: Scale
};

const LibraryTool = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('worth-it');

  const activeStories = realDecisions.categories.find(c => c.id === activeCategory)?.stories || [];

  return (
    <div className="min-h-screen py-12 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <button
          onClick={() => navigate('/ferramentas')}
          className="flex items-center gap-2 text-[#8B7D6B] hover:text-[#6B4E37] mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          Voltar às ferramentas
        </button>

        <div className="text-center mb-12">
          <div className="w-16 h-16 rounded-2xl bg-[#E8D5D5]/30 flex items-center justify-center mx-auto mb-6">
            <BookOpen size={32} className="text-[#6B4E37]" />
          </div>
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#2C2C2C] mb-4">
            {realDecisions.title}
          </h1>
          <p className="text-lg text-[#6B4E37] max-w-xl mx-auto">
            {realDecisions.subtitle}
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {realDecisions.categories.map((category) => {
            const Icon = iconMap[category.icon];
            const isActive = activeCategory === category.id;
            
            return (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center gap-2 px-5 py-3 rounded-full transition-all duration-300 ${
                  isActive
                    ? 'bg-[#C4B5A0] text-white shadow-md'
                    : 'bg-white/60 text-[#6B4E37] hover:bg-white/80'
                }`}
              >
                <Icon size={18} />
                <span className="text-sm font-medium">{category.name}</span>
              </button>
            );
          })}
        </div>

        {/* Stories */}
        <div className="space-y-6">
          {activeStories.map((story) => (
            <div 
              key={story.id}
              className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-sm"
            >
              {/* Title */}
              <h3 className="font-['Cormorant_Garamond'] text-2xl text-[#2C2C2C] mb-2">
                {story.title}
              </h3>
              
              {/* Couple */}
              <p className="text-sm text-[#C4B5A0] mb-6">— {story.couple}</p>

              {/* Story */}
              <div className="relative pl-6 border-l-2 border-[#D4C4B0]/50 mb-6">
                <Quote size={20} className="absolute -left-3 -top-1 bg-[#FAF9F7] text-[#D4C4B0]" />
                <p className="text-[#6B4E37] leading-relaxed italic">
                  {story.story}
                </p>
              </div>

              {/* Lesson */}
              <div className="bg-[#F5F3F0] rounded-lg p-4 flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#B5C4B1]/30 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm">💡</span>
                </div>
                <div>
                  <span className="text-xs font-medium text-[#8B7D6B] uppercase tracking-wider">Lição</span>
                  <p className="text-[#2C2C2C] font-medium mt-1">{story.lesson}</p>
                </div>
              </div>

              {/* Impact Badge */}
              <div className="mt-4 flex justify-end">
                <span className={`text-xs px-3 py-1 rounded-full ${
                  story.impact === 'alta'
                    ? 'bg-[#B5C4B1]/30 text-[#6B4E37]'
                    : 'bg-[#D4C4B0]/30 text-[#6B4E37]'
                }`}>
                  Impacto {story.impact}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-[#8B7D6B] max-w-md mx-auto">
            Estas histórias são reais e partilhadas com permissão. 
            Cada casal é único - usem como inspiração, não como regra.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LibraryTool;
